import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {FooterLogoMobile, FooterLogoProps} from '../components/footer-logo/FooterLogo@mobile'
import {footerClasses} from './Footer@mobile.classes'

type FooterProps = {
  footerLogo: FooterLogoProps
  footerApp: React.ReactNode
  legal?: React.ReactNode
  storeDisclaimers?: React.ReactNode
  footerIcons: React.ReactNode
  legalLinks: React.ReactNode
  navLinkList: React.ReactNode
  seoHeading: React.ReactNode
}

export function Footer({
  footerLogo,
  footerApp,
  legal,
  storeDisclaimers,
  footerIcons,
  navLinkList,
  legalLinks,
  seoHeading,
}: FooterProps): React.ReactElement {
  return (
    <footer className={footerClasses.root} id="footer">
      <div className={footerClasses.footerContainer}>
        <Grid className={footerClasses.firstLine} direction="column" justify="space-between" wrap="nowrap" container>
          <Grid className={footerClasses.logoContainer} item>
            <FooterLogoMobile {...footerLogo} />
          </Grid>
          <Grid className={footerClasses.appContainer} item>
            {footerApp}
          </Grid>
        </Grid>
        <Grid direction="column" container>
          <Grid className={footerClasses.navigation} item>
            {navLinkList}
          </Grid>
          <Grid item>{seoHeading}</Grid>
          <Grid className={clsx(footerClasses.legal, footerClasses.caption1)} direction="column" container item>
            <Grid item>{legal}</Grid>
            <Grid item>{storeDisclaimers}</Grid>
          </Grid>

          <Grid className={footerClasses.legalLinks} direction="column" wrap="nowrap" container item>
            {legalLinks}
          </Grid>

          <Grid justify="space-between" wrap="nowrap" container item>
            {footerIcons}
          </Grid>
        </Grid>
      </div>
    </footer>
  )
}
